<mat-spinner
	*ngIf="mode === 'spinner'"
	[class.skeleton]="forSkeleton"
	[diameter]="size"
></mat-spinner>
